/*
 * Extracts plain text from a Slate document (array of nodes).
 * Top-level blocks are joined with newlines; leaf `text` values within a block
 * are concatenated. Used to render sentence-completion stems in print views
 * without instantiating a Slate editor.
 */

const nodeText = (node) => {
  if (typeof node.text === 'string') return node.text;
  if (Array.isArray(node.children)) {
    return node.children.map(nodeText).join('');
  }
  return '';
};

export const slateToPlainText = (nodes) => {
  if (!Array.isArray(nodes) || nodes.length === 0) return '';
  return nodes.map(nodeText).join('\n');
};
